import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import {cloneDeep} from "lodash";
import Header from "../Header";
import Sidebar from "../Sidebar";
// import SecondStepBenchmark from "./Components/SecondStepBenchmark";
import { ApiService } from "../../../services/ApiService";
import {setAccounts, setReLoginRequiredInstitutes} from "../../../redux/modules/accounts/accountsActions";
import { setCosts } from "../../../redux/modules/manualCosts/costsActions";
import { fetchCards, setCards } from "../../../redux/modules/cards/cardsActions";
import { setDashboardStep } from "../../../redux/modules/dashboardStep/dashboardStepActions";
import {setResultSetting} from "../../../redux/modules/resultSetting/resultSettingActions";
import {
  getStoredAccounts,
  getStoredCosts,
  removeComma,
  getDateQuery,
  getDateRanges,
  modifyCardsList,
  isUserLoggedIn,
  getStoredCards,
  getManualStoredValue,
  COSTS_BENCHMARK,
  CURRENT_YEAR,
  CURRENT_MONTH_SHORT,
  CURRENT_MONTH_LONG,
  FILTER_CARDS,
  CONTEXT_ARRAY,
  GET_CONTEXT_VARIABLES
} from "../../../utils/constants";
import "../../../common/styles/dashboard.scss";
import "../../../common/styles/carousel.scss";
import "../../../common/styles/bestcards.scss";
import HiWc from "../../../assets/images/hiw-c.svg";
import _ from "lodash";
import { useState, useEffect, useRef } from "react";

import { Divider, Tooltip } from "antd";
import Help from "../../../assets/images/dashboard/help-icon.svg";

import { Loading } from '../../../common/components/Loading/Loading';
import CardDetailsCarousel from "../Dashboard/Components/SecondStep/component/CardDetailsCarousel"
import CardInfoPanel from "../Dashboard/Components/SecondStep/component/CardInfoPanel"
import FilterSettings from "../Dashboard/Components/SecondStep/component/FilterSettings";
import FilterPills from "../Dashboard/Components/SecondStep/component/FilterPills";
import HorizontalCardsList from "../Dashboard/Components/SecondStep/component/RecommendedCards/component/HorizontalCardsList"
import CardDetailsModal from "../Dashboard/Components/SecondStep/component/CardDetailsModal"
import {Link} from "react-router-dom";
import { Helmet } from "react-helmet";
import AverageAmericanSpend from "../Dashboard/Components/SecondStep/component/AverageAmericanSpend";
import PersonalizedLinkBanner from "./PersonalizedLinkBanner";





/**
 *
 *
 */
const BestCardsFor = (args) => {
  
  // 
  const { 
    match, 
    onFetchCards, 
  } = args || {};
  
  // params
  const { params } = match || {};
  
  // 
  const { context } = params || {};
  
  // 
  const [isFindingCards, setIsFindingCards] = useState(false);
  const [isOops, setIsOops] = useState(false);
  
  // 
  const [cardDetailsModalData, setCardDetailsModalData] = useState(null); // if not null, opens modal window
  const [fetchResults, setFetchResults] = useState(null);
  const prevContextRef = useRef(null);
  
  // fixed constants for top carousel
  const topYearProjection = "1";
  const topIncludedIntroBonus = GET_CONTEXT_VARIABLES(context).isIncludeIntroBonus;
  
  // filters for mid carousel
  const [filterYearProjection, setFilterYearProjection] = useState(topYearProjection);
  const [filterIncludedIntroBonus, setFilterIncludedIntroBonus] = useState(topIncludedIntroBonus);
  const [filterSelectedCategories, setFilterSelectedCategories] = useState(GET_CONTEXT_VARIABLES(context).selectedCategories);
  const [filterSelectedFeatures, setFilterSelectedFeatures] = useState(GET_CONTEXT_VARIABLES(context).selectedFeatures);
  
  // overall best page
  const isNoContext = !context;
  
  // check if fetch needed
  useEffect(() => {
    
    if (prevContextRef.current !== context) {
      
      // set loading state
      setIsFindingCards(true);
      
      // costs
      const { costs } = isNoContext? { costs: COSTS_BENCHMARK } : ( GET_CONTEXT_VARIABLES(context) || {} );
      const { grocery, gas, restaurant, other, recreation, travel } = costs || {};
      
      // dates
      const dateRange = getDateRanges(1);
      const dateQuery = `&startDate=${moment((dateRange || [])[0]).format("YYYY-MM-DD")}&endDate=${moment((dateRange || [])[1]).format("YYYY-MM-DD")}&nMonths=${12}`;
      
      // query
      const query = `?1=${removeComma(grocery)}&2=${removeComma(gas)}&4=${removeComma(restaurant)}&5=${removeComma(other)}&8=${removeComma(recreation)}&9=${removeComma(travel)}${dateQuery}`;

      // fetch
      onFetchCards({
        apiEndpoint: "free/run-backtest-manual",
        query: query,
        onSuccess: (res) => {
          setFetchResults(res);
          setIsFindingCards(false);
          window.scrollTo({ top: 0, behavior: "smooth" });
        },
        onFail: (response) => {
          setIsOops(true);
          setIsFindingCards(false);
        }
      });
      
      // reset filters
      const contextVars = GET_CONTEXT_VARIABLES(context);
      setFilterIncludedIntroBonus(contextVars.isIncludeIntroBonus);
      setFilterSelectedCategories(contextVars.selectedCategories);
      setFilterSelectedFeatures(contextVars.selectedFeatures);
      
      // update ref
      prevContextRef.current = context;
    }
  }, [context, onFetchCards]);
  
  
  /**
   *
   *
   */
  const getCardsList = ({ isIntroBonus, yearProj, selectedCats, selectedFeats }) => {
    
    // handle empty
    if (!fetchResults) {
      return [];
    }
    
    // intro bonus included?
    const r = isIntroBonus? fetchResults.results : fetchResults.noBonus_results;
    
    // projection years?
    const resultsList = _.cloneDeep(r?.[yearProj] || []);
    
    // this modify combines cards with results
    const cardList = modifyCardsList([...resultsList], fetchResults.cards || {});
    
    // filter
    let filteredList = cardList;
    if ((selectedCats || []).length || (selectedFeats || []).length) {
      filteredList = FILTER_CARDS(cardList, selectedCats, selectedFeats);
    }
    
    // sort
    const sortedList = _.orderBy(filteredList, ["totalMoney", 'cardName'], "desc");
    
    // 
    return sortedList;
  }
  
  // 
  const {
    headlineFor,
    firstParagraph,
    secondParagraph,
    selectedFeatures: topSelectedFeatures,
    selectedCategories: topSelectedCategories,
    costs,
    seoTitle,
    seoDescription
  } = GET_CONTEXT_VARIABLES(context) || {};
  
  
  //
  const avgSpending = fetchResults?.avgSpending || 0;
  const spending = fetchResults?.spending || 0;

  //
  const isLoading = isFindingCards;

  const title = seoTitle;
  const description = seoDescription;
  const linkRel = "https://joinluci.com/best-credit-cards/"+context;
  
  // cards to show
  const N_VISIBLE_CARDS = 3;
  const visibleCards = _.take(
    getCardsList({
      isIntroBonus: topIncludedIntroBonus, 
      yearProj: topYearProjection, 
      selectedCats: topSelectedCategories, 
      selectedFeats: topSelectedFeatures,
    }), N_VISIBLE_CARDS)
    ;
    
  // filtered cards to show (bottom section)
  const N_VISIBLE_FILTERED_CARDS = 10;
  const visibleFilteredCards = _.take(
    getCardsList({
      isIntroBonus: filterIncludedIntroBonus, 
      yearProj: filterYearProjection, 
      selectedCats: filterSelectedCategories, 
      selectedFeats: filterSelectedFeatures,
    }), N_VISIBLE_FILTERED_CARDS)
  ;


  // scroll to hash once loading state completes
  // const isInitLoadComplete = useRef(false);
  useEffect(() => {
    // if (!isInitLoadComplete.current) { return; }
    if (!isLoading && fetchResults) { // null is pre-load. true is while loading, and false is done loading.
      // isScrolled.current = true;
      const hash = window.location.hash;
      if (hash) {
          const el = document.querySelector(hash);
          if (el) {
            setTimeout(() => {
              el.scrollIntoView({ behavior: "smooth" });
            }, 300); // delay to make it work
          }
      }
    }
  }, [isLoading, fetchResults]);


  // 
  return (
    <div className="dashboard-wrapper">

      <Header/>
      <Helmet>
        <title>{title}</title>
        <link rel="canonical" href={linkRel}/>
        <meta name="description" content={description}/>
        <meta property="og:title" content={title}/>
        <meta property="og:description" content={description}/>
        <meta name="twitter:title" content={title}/>
        <meta name="twitter:description" content={description}/>
      </Helmet>
      
      <section>
        <div className="wrapper profile-sidebar">
          <div id="content" className="">
          
            <div className="card luci-card second-step">
            
              <div className="card-body" style={{padding: "0px 5px"}}>
              
                {/* title */}
                <h1 className="luci-title mb-4" style={{fontSize: "32px", fontWeight: "200", letterSpacing: "-0.2px"}}>
                  {"Best Credit Cards" + (isNoContext? "" : " for " + headlineFor)}
                  <span style={{display: "inline-block"}}>
                    &nbsp;-&nbsp;{CURRENT_MONTH_SHORT} {CURRENT_YEAR}
                  </span>
                </h1>
                
                {/* paragraphs */}
                {isNoContext? 
                  <>
                    <div className="mb-3" style={{fontWeight: 200}}>
                      We’ve rounded up the best credit cards based on how the average American spends — and you can personalize your results even further. Whether you’re after cash back, travel rewards, or a strong intro offer, these cards offer serious value without the guesswork.
                      Get personalized recommendations<a href="/find-best-card-for-your-spend" className="ml-1 ga-recsFlowClick ga-recsFlowClick-section1">here</a>!
                    </div>
                    <AverageAmericanSpend/>
                  </>
                  :
                  <>
                    <div className="mb-3" style={{fontWeight: 200}}>
                      {firstParagraph}
                    </div>
                    <AverageAmericanSpend/>
                    <div className="mb-4" style={{fontWeight: 200}}>
                      {secondParagraph}
                    </div>
                  </>
                }
              </div>
              
              
              <div className="card-body padd-xs">
              
                {isLoading ?
                  <div className="text-center mt-100"><Loading isInteral={true} isCenter={true}/></div>
                  :
                  <>
                    
                    {
                      // card panels
                      visibleCards.map((card, index) =>
                        <CardInfoPanel {...{ 
                            key: index,
                            card, 
                            index, 
                            avgSpending,
                            spending,
                            topYearProjection,
                            topIncludedIntroBonus,
                            sectionNumber: 1,
                        }}/>
                      )
                    }
                    
                    {/* banner */}
                    <PersonalizedLinkBanner/>
                    
                    
                    <Divider style={{marginBottom: 0}}/>
                    
                    <div className="filter-section-banner">
                      <div className="filter-section-title">
                        Explore the Best Credit Cards for Your Needs
                      </div>
                      <div className="filter-section-text">
                        Compare top credit cards based on rewards, cashback, and benefits. Find the perfect card that matches your lifestyle.
                      </div>
                    </div>
                    
                    {/* filter - pills */}
                    <FilterPills {...{
                      selectedCategories: filterSelectedCategories,
                      selectedFeatures: filterSelectedFeatures,
                      onDismissFilter: () => {
                        setFilterYearProjection("1");
                        setFilterIncludedIntroBonus(true);
                        setFilterSelectedCategories([]);
                        setFilterSelectedFeatures([]);
                      },
                      onFilterChange: (type, value) => {
                        let list = [];
                        if (type == "selectedCategories") {
                          list = _.cloneDeep(filterSelectedCategories);
                        } else if (type == "selectedFeatures") {
                          list = _.cloneDeep(filterSelectedFeatures);
                        }
                        if((list || []).includes(value)) {
                          list = (list || []).filter(x => x !== value)
                        } else {
                          list.push(value)
                        }
                        if (type == "selectedCategories") {
                          setFilterSelectedCategories(list);
                        } else if (type == "selectedFeatures") {
                          setFilterSelectedFeatures(list);
                        }
                      },
                      setFilterSelectedCategories,
                      setFilterSelectedFeatures,
                      isIncludeIntroBonus: filterIncludedIntroBonus,
                      onIncludeIntroChange: (isInclude) => { setFilterIncludedIntroBonus(isInclude); },
                      yearProjection: filterYearProjection,
                      onYearProjectionChange: (yr) => { setFilterYearProjection(yr); },

                      defaultIsIntroBonus: GET_CONTEXT_VARIABLES(context).isIncludeIntroBonus,
                      defaultSelectedCategories: GET_CONTEXT_VARIABLES(context).selectedCategories,
                      defaultSelectedFeatures: GET_CONTEXT_VARIABLES(context).selectedFeatures
                    }}/>
                    
                    {visibleFilteredCards.length?
                      <div className="empty-message">
                        Showing {visibleFilteredCards.length} result{visibleFilteredCards.length > 1? "s" : ""}.
                      </div>
                      :
                      <div className="empty-message">
                        No cards found for the specified filters.
                      </div>
                    }
                    
                    {
                      // card panels
                      visibleFilteredCards.map((card, index) =>
                        <CardInfoPanel {...{ 
                            key: index,
                            card, 
                            index, 
                            avgSpending,
                            spending,
                            topYearProjection: filterYearProjection,
                            topIncludedIntroBonus: filterIncludedIntroBonus,
                            isTopPickHighlight: false,
                            sectionNumber: 2,
                        }}/>
                      )
                    }
                    
                    {/* divider */}
                    <Divider style={{marginTop: 25, marginBottom: 30}}/>
                    
                    {/* discovery */}
                    <div className="discovery-banner">
                      <div className="discovery-banner-header">
                        Looking for a particular type of rewards credit card?
                      </div>
                      
                      <div className="discovery-banner-text">
                        Find the best rewards credit card for your specific needs - whether it's groceries, dining, travel, or gas. Tap on a category to explore your options!
                      </div>
                      
                      <div className="mt-4 mb-1" style={{display: "flex", flexWrap: "wrap", columnGap: "10px", rowGap: "15px", justifyContent: "flex-start"}}>

                        {/* current best caards */}
                        {context?
                          <Link to={"/current-best-cards"} key={"best"}>
                            <button className="btn luci-btn white-btn" style={{whiteSpace: "nowrap", fontSize: "16px"}}>
                              &#x1F3C6; Current Best Cards
                            </button>
                          </Link>
                          : null // hide if current page
                        }

                        {/* link to all other contexts */}
                        {_.map(CONTEXT_ARRAY, el => {
                          const contextVars = GET_CONTEXT_VARIABLES(el);
                          if (el == context) { return null; } // skip current page
                          return (
                            <Link to={`/best-credit-cards/${el}`} key={el}>
                              <button className="btn luci-btn white-btn" style={{whiteSpace: "nowrap", fontSize: "16px"}}>
                                {contextVars.emoji} {contextVars.headlineFor}
                              </button>
                            </Link>
                          );
                        })}
                      </div>
                    </div>
                    
                    {/* divider */}
                    <Divider style={{marginTop: 25, marginBottom: 30}}/>
                    
                    {/* banner */}
                    <PersonalizedLinkBanner isDark={true}/>
                  </>
                }
              </div>
            </div>
            
            {/* card details modal */}
            {cardDetailsModalData ?
              <CardDetailsModal
                selectedCardInfo={cardDetailsModalData || {}}
                onCancel={() => setCardDetailsModalData(null)}
              />
              : null
            }
            
            {/* error message */}
            {isOops?
              <div className="mt-60 text-center w-100">
                <h3>{ "Oops, Something went wrong. Please try again later." }</h3>
              </div>
              : null
            }
          </div>
        </div>
      </section>
    </div>
  );
}


const mapStateToProps = state => {
  return {};
}

const mapDispatchToProps = dispatch => {
  return {
    onFetchCards: data => {
      dispatch(fetchCards(data));
    },
  };
};

export default connect(null, mapDispatchToProps)(BestCardsFor);
